import React from 'react';
import './TriggerRealTimeView.styl';

export default class TriggerTrendView extends React.Component {
  render() {
    return (
      <div className="triggers-real-time-view trigger-container">
        <header>
          <div className="info">
            <div className="title">Real Time</div>
            <div className="description">Each time event occurs</div>
          </div>
        </header>
        <div className="trigger-actions-content trigger-content">Respond Immediately</div>
      </div>
    );
  }
}
